import Svg, { SvgProps, Path } from 'react-native-svg';

export const NotAuthorisedIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 60 60" width={60} height={60} fill="#FFFFFF" {...props}>
    <Path d="M30 6C16.746 6 6 16.746 6 30s10.746 24 24 24 24-10.746 24-24S43.254 6 30 6Zm16 28a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v8Z" />
  </Svg>
);
